import { styled, Box } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { pxToRem } from '@withjoy/joykit/theme';
import { responsiveBreakpoints } from '@apps/registry/common/utils/responsiveHelpers';
import { StyledInputContainer } from '@withjoy/joykit/components/InputV1/StyledInputContainer';
import { CSSProperties } from 'react';

const nonZeroProductListStyles: CSSObject = {
  gridTemplateColumns: {
    _: 'repeat(2, minmax(140px, 1fr))',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(2, minmax(0, 1fr))',
    md2: 'repeat(3, minmax(0, 1fr))',
    lg: 'repeat(4, minmax(0, 1fr))',
  },
  gridTemplateRows: '1fr',
  gridColumnGap: {
    _: pxToRem(16),
    md2: pxToRem(24),
    lg: pxToRem(16),
  },
  gridRowGap: {
    _: pxToRem(24),
    md2: pxToRem(32),
    lg: pxToRem(32),
  },
};

const selectStyles: CSSProperties = {
  border: 'none',
  outline: 'none',
  height: pxToRem(48),
  textAlign: 'right',
  fontSize: pxToRem(15),
};

const selectWrapperStyles: CSSObject = {
  [`${StyledInputContainer} > input`]: {
    textAlign: 'right',
    paddingRight: '0 !important',
    marginRight: `${pxToRem(48)}`,
    width: `${pxToRem(240)}`,
    background: 'transparent',
  },
};

export const SelectWrapper = styled(Box)``;

export const StyledSelect = styled.select`
  padding: 0 ${pxToRem(24)};
  background: none;
`;

export const StyledGridContainer = styled(Box)<{ numberOfItems: number }>`
  display: grid;

  // Final items in grid should never have a bottom line (see COMMERCE-368).
  // Need to calculate the number of last children for each layout (desktop - 4 columns, tablet - 3 columns. etc.)
  & > div {
    @media (min-width: ${responsiveBreakpoints.SIZE_1440}) {
      &:nth-last-child(-n + ${({ numberOfItems }) => (numberOfItems % 4 === 0 ? 4 : numberOfItems % 4)}):after {
        content: unset;
      }
    }
    @media (max-width: calc(${responsiveBreakpoints.SIZE_1440} - 1px)) {
      &:nth-last-child(-n + ${({ numberOfItems }) => (numberOfItems % 3 === 0 ? 3 : numberOfItems % 3)}):after {
        content: unset;
      }
    }
    @media (max-width: calc(${responsiveBreakpoints.SIZE_1152} - 1px)) {
      &:nth-last-child(-n + ${({ numberOfItems }) => (numberOfItems % 2 === 0 ? 2 : numberOfItems % 2)}):after {
        content: unset;
      }
    }
  }
`;

export const styles = {
  nonZeroProductListStyles: nonZeroProductListStyles,
  selectStyles: selectStyles,
  selectWrapperStyles: selectWrapperStyles,
};
